export default __webpack_public_path__ + "static/media/details_active.749e9323.svg";